@if (labelText(); as text) {
    <div role="presentation" class="qpx-cmdk-group-label">
        {{ text }}
    </div>
}
@if (labelTemplate(); as templateRef) {
    <div role="presentation" class="qpx-cmdk-group-label">
        <ng-container [ngTemplateOutlet]="templateRef" />
    </div>
}
<div
    class="qpx-cmdk-group-content"
    role="group"
    [attr.aria-label]="ariaLabel()"
>
    <ng-content />
</div>
